var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#BABABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 57V52.3555C57 49.892 55.8561 47.5293 53.82 45.7873C51.7839 44.0453 49.0223 43.0667 46.1429 43.0667H29.8571C26.9776 43.0667 24.2161 44.0453 22.18 45.7873C20.1439 47.5293 19 49.892 19 52.3555V57",
    stroke: "#4A4A4A",
    strokeWidth: 3.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9995 32.9333C43.596 32.9333 48.1329 28.3964 48.1329 22.8C48.1329 17.2035 43.596 12.6666 37.9995 12.6666C32.4031 12.6666 27.8662 17.2035 27.8662 22.8C27.8662 28.3964 32.4031 32.9333 37.9995 32.9333Z",
    stroke: "#4A4A4A",
    strokeWidth: 3.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultProfile);
export default __webpack_public_path__ + "static/media/user_default_profile.fc8bda972b6fe47d92b9b8a789c91aa6.svg";
export { ForwardRef as ReactComponent };